import React, { useEffect } from 'react';
import cn from 'classnames';

// CSS
import styles from '@UILayer/UILayer.scss';

//PANELS
import { BalanceInfo, BetInfo, GamePlayInformation, WinningInformation } from '..';
import { useAppSelector } from '@Managers/Redux/Hooks';
import { getGlobalStyles } from '@Managers/Redux/AppState/AppState';

const StatusPortrait: React.FC<{}> = () => {
    const globalStyles = useAppSelector(getGlobalStyles);

    return (
        <div className={cn(styles.statusPortrait_container, globalStyles.isTablet, globalStyles.orientation)}>
            <div className={styles.statusPortrait_wrapper}>
                <div className={styles.statusPortrait_winning_information}>
                    <WinningInformation />
                </div>
                <div className={styles.statusPortrait_gameplay_information}>
                    <GamePlayInformation />
                </div>
                <div className={styles.statusPortrait_account}>
                    <BalanceInfo />
                    <BetInfo />
                </div>
            </div>
        </div>
    );
};

export default StatusPortrait;
